'use strict';

(function($) {

    var pluginName = 'kumsalPanel';

    // plugin setup
    $.fn[pluginName] = function(options) {
        if ($(this).length === 0) {
            return;
        }

        // global variables
        var panel = this;


        var Plugin = {
            isInit: false,
            options: {
                selector: false,
            },
            calculate:function(){
                var value = panel.val();
                value = typeof value !== 'undefined' && value !== '' ? value : '0';

                $('.panel-container[data-selector='+panel.options.selector+']').each(function () {
                    var values = Array.isArray($(this).data('value')) ? $(this).data('value') : [];
                    $.inArray(value,values) != -1 ?
                        $(this).removeClass('d-none') :
                        $(this).addClass('d-none');
                });
            },
            initEvents:function(){
                panel.change(function () {
                    panel.calculate();
                });
            },
            init: function() {
                panel.options = panel.data();

                panel.options.selector = panel.options.selector || '';

                panel.calculate();

                panel.initEvents();

                return panel;
            },
        };

        /**
         * Public API methods can be used directly by datatable
         */
        $.each(Plugin, function(funcName, func) {
            panel[funcName] = func;
        });


        if (!panel.isInit){
            panel.init();
        }

        return panel;
    };

}(jQuery));

$('document').ready(function () {

});